import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, AlertController, LoadingController } from '@ionic/angular/lazy';
import { CartService } from 'src/app/services/cart.service';
import { UserService } from 'src/app/services/user.service';
import { DateTimePickerPage } from 'src/app/modals/date-time-picker/date-time-picker.page';
import moment from 'moment';
import { Capacitor } from '@capacitor/core';
import { StorageService } from 'src/app/services/storage.service';
import { ConnectedAccountService } from 'src/app/services/connected-account.service';

@Component({
    selector: 'app-cart-pickup',
    templateUrl: './cart-pickup.page.html',
    styleUrls: ['./cart-pickup.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CartPickupPage implements OnInit {

    cart = null;
    spinner = null;
    moment = moment;
    modal_css_class = '';
    date_modal_css_class = '';
    formatted_pickup_date = null;

    params = {
        pickup: true
    };

    // modal flags
    date_picker_modal_open = false;

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private cartService: CartService,
        private storageService: StorageService,
        private connectedAccountService: ConnectedAccountService,
        private loadingController: LoadingController,
        private userService: UserService
    ) { }

    ngOnInit() {
        
        if(Capacitor.isNativePlatform()) {
            this.modal_css_class = 'fullscreen';
            this.date_modal_css_class = 'backdrop';
        }

        this.cartService.get().then((cart) => {

            if(cart) {

                this.cart = cart;

                if(cart['pickup']) {
                    this.params['pickup'] = cart['pickup'];
                }

                if(cart['pickup_date']) {
                    this.storageService.get("connected_account_id").then((connected_account_id) => {
                        if(connected_account_id) {
                            this.connectedAccountService.getConnectedAccount(connected_account_id).then((connected_account: any) => {
                                if(connected_account['user_id']) {
                                    this.userService.getUser(connected_account['user_id']).then((user: any) => {
                                        this.params['pickup_date'] = this.moment.utc(cart['pickup_date']).tz(user.timezone.code).toISOString(true);
                                        this.formatted_pickup_date = this.moment(this.params['pickup_date']).format("D MMM YYYY, HH:mm");
                                    });
                                }
                            })
                            .catch(() => { });
                        }
                    })
                    .catch(() => { });
                }

            }
        });

    }

    close() {
        this.modalController.dismiss();
    }

    update() {
        this.presentSpinner("Adding pickup").then(async () => {

            let validated = true;

            if(validated) {

                if(this.params['pickup_date']) {
                    this.params['pickup_date'] = this.moment(this.params['pickup_date']).utc().toISOString();
                }

                this.cartService.updatePickup(this.params).then(async () => {
                    await this.spinner.dismiss();
                    await this.modalController.dismiss();
                })
                .catch(() => {
                    this.spinner.dismiss();
                });

            }
            else {
                this.spinner.dismiss();
            }

        })
        .catch(() => {
            this.spinner.dismiss();
        });
    }

    async presentDateTimePickerModal() {
        if(!this.date_picker_modal_open) {
            this.date_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: DateTimePickerPage,
                cssClass: this.date_modal_css_class,
                componentProps: {
                    date: (this.params['pickup_date'] ? this.params['pickup_date'] : ""),
                    format: "date-time",
                    clear_date: true
                }
            })
            modal.onDidDismiss().then((data) => {
                this.date_picker_modal_open = false;
                if(data.data) {
                    if(data.data == "date_deleted") {
                        this.params['pickup_date'] = "";
                        this.formatted_pickup_date = null;
                    }
                    else {
                        this.params['pickup_date'] = data.data['date'];
                        this.formatted_pickup_date = this.moment(this.params['pickup_date']).format("D MMM YYYY, HH:mm");
                    }
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

}
